import React from "react";
import { useQuickSightKiro  } from "@/hooks/useKiroReports";

const QuickSightAwsKiroDashboard = () => {
  const { embedUrl } = useQuickSightKiro ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsKiroDashboard;
